module.exports = __webpack_public_path__ + "img/onservice-no-text.0a840522.svg";